// Modèles de convention prédéfinis
export const TEMPLATES = {
  cooper: {
    name: "Convention COOPER'S",
    content: `<div style="font-family: 'Times New Roman', serif; padding: 20px;">
  <div style="text-align: center; margin-bottom: 30px;">
    <h1 style="color: #1e40af; margin-bottom: 10px;">CONVENTION DE PARTENARIAT</h1>
    <h2 style="color: #3b82f6;">COOPER'S - O'SCOP</h2>
  </div>
  
  <p style="margin-bottom: 20px;"><strong>Entre les soussignés :</strong></p>
  
  <p style="margin-bottom: 15px;">
    <strong>O'SCOP</strong>, représentée par son Président, ci-après dénommée "O'SCOP"<br/>
    D'une part,
  </p>
  
  <p style="margin-bottom: 20px;">
    Et<br/>
    <strong>[NOM DU COOPER'S]</strong>, [FORME JURIDIQUE], immatriculée sous le numéro [SIRET]<br/>
    Représentée par [NOM DU REPRÉSENTANT], en qualité de [QUALITÉ]<br/>
    Ci-après dénommée "Le Partenaire"<br/>
    D'autre part,
  </p>
  
  <h3 style="color: #1e40af; border-bottom: 2px solid #3b82f6; padding-bottom: 5px;">Article 1 - Objet</h3>
  <p style="margin-bottom: 15px;">La présente convention a pour objet de définir les conditions de partenariat entre O'SCOP et le Partenaire dans le cadre du réseau COOPER'S.</p>
  
  <h3 style="color: #1e40af; border-bottom: 2px solid #3b82f6; padding-bottom: 5px;">Article 2 - Durée</h3>
  <p style="margin-bottom: 15px;">La présente convention est conclue pour une durée de <strong>[DURÉE] mois</strong> à compter de sa signature.</p>
  
  <h3 style="color: #1e40af; border-bottom: 2px solid #3b82f6; padding-bottom: 5px;">Article 3 - Engagements du Partenaire</h3>
  <ul style="margin-bottom: 15px;">
    <li>Respecter la charte qualité O'SCOP</li>
    <li>Participer aux formations obligatoires</li>
    <li>Contribuer au développement du réseau</li>
  </ul>
  
  <h3 style="color: #1e40af; border-bottom: 2px solid #3b82f6; padding-bottom: 5px;">Article 4 - Engagements d'O'SCOP</h3>
  <ul style="margin-bottom: 15px;">
    <li>Accompagnement personnalisé</li>
    <li>Accès aux outils et ressources du réseau</li>
    <li>Visibilité sur la plateforme O'SCOP</li>
  </ul>
  
  <h3 style="color: #1e40af; border-bottom: 2px solid #3b82f6; padding-bottom: 5px;">Article 5 - Confidentialité</h3>
  <p style="margin-bottom: 15px;">Les parties s'engagent à maintenir la confidentialité des informations échangées dans le cadre de cette convention.</p>
  
  <div style="margin-top: 40px;">
    <p><strong>Fait à [LIEU], le [DATE]</strong></p>
    <p>En deux exemplaires originaux.</p>
    
    <div style="display: flex; justify-content: space-between; margin-top: 30px;">
      <div style="text-align: center; width: 45%;">
        <p><strong>Pour O'SCOP</strong></p>
        <p style="margin-top: 50px; border-top: 1px solid #000;">Le Président</p>
      </div>
      <div style="text-align: center; width: 45%;">
        <p><strong>Pour le Partenaire</strong></p>
        <p style="margin-top: 50px; border-top: 1px solid #000;">[NOM DU SIGNATAIRE]</p>
      </div>
    </div>
  </div>
</div>`
  },
  expert: {
    name: "Convention EXPERT",
    content: `<div style="font-family: 'Times New Roman', serif; padding: 20px;">
  <div style="text-align: center; margin-bottom: 30px;">
    <h1 style="color: #059669; margin-bottom: 10px;">CONVENTION D'EXPERTISE</h1>
    <h2 style="color: #10b981;">RÉSEAU EXPERTS O'SCOP</h2>
  </div>
  
  <p style="margin-bottom: 20px;"><strong>Entre les soussignés :</strong></p>
  
  <p style="margin-bottom: 15px;">
    <strong>O'SCOP</strong>, représentée par son Président<br/>
    D'une part,
  </p>
  
  <p style="margin-bottom: 20px;">
    Et<br/>
    <strong>[NOM DE L'EXPERT]</strong>, Expert en [DOMAINE D'EXPERTISE]<br/>
    Immatriculé sous le numéro [SIRET]<br/>
    Ci-après dénommé "L'Expert"<br/>
    D'autre part,
  </p>
  
  <h3 style="color: #059669; border-bottom: 2px solid #10b981; padding-bottom: 5px;">Article 1 - Missions</h3>
  <p style="margin-bottom: 15px;">L'Expert s'engage à fournir ses services d'expertise aux membres du réseau O'SCOP dans les domaines suivants :</p>
  <ul style="margin-bottom: 15px;">
    <li>Conseil technique</li>
    <li>Audit et diagnostic</li>
    <li>Formation spécialisée</li>
  </ul>
  
  <h3 style="color: #059669; border-bottom: 2px solid #10b981; padding-bottom: 5px;">Article 2 - Rémunération</h3>
  <p style="margin-bottom: 15px;">Les modalités de rémunération sont définies selon le barème en vigueur du réseau O'SCOP.</p>
  
  <h3 style="color: #059669; border-bottom: 2px solid #10b981; padding-bottom: 5px;">Article 3 - Durée</h3>
  <p style="margin-bottom: 15px;">Convention valable <strong>[DURÉE] mois</strong>, renouvelable par tacite reconduction.</p>
  
  <div style="margin-top: 40px;">
    <p><strong>Fait à [LIEU], le [DATE]</strong></p>
    
    <div style="display: flex; justify-content: space-between; margin-top: 30px;">
      <div style="text-align: center; width: 45%;">
        <p><strong>Pour O'SCOP</strong></p>
        <p style="margin-top: 50px; border-top: 1px solid #000;">Le Président</p>
      </div>
      <div style="text-align: center; width: 45%;">
        <p><strong>L'Expert</strong></p>
        <p style="margin-top: 50px; border-top: 1px solid #000;">[NOM]</p>
      </div>
    </div>
  </div>
</div>`
  },
  autre: {
    name: "Convention Personnalisée",
    content: `<div style="font-family: 'Times New Roman', serif; padding: 20px;">
  <div style="text-align: center; margin-bottom: 30px;">
    <h1 style="color: #7c3aed; margin-bottom: 10px;">CONVENTION DE PARTENARIAT</h1>
  </div>
  
  <p style="margin-bottom: 20px;"><strong>Entre les soussignés :</strong></p>
  
  <p style="margin-bottom: 15px;">
    <strong>O'SCOP</strong><br/>
    D'une part,
  </p>
  
  <p style="margin-bottom: 20px;">
    Et<br/>
    <strong>[NOM DU PARTENAIRE]</strong><br/>
    D'autre part,
  </p>
  
  <h3 style="color: #7c3aed; border-bottom: 2px solid #8b5cf6; padding-bottom: 5px;">Article 1 - Objet</h3>
  <p style="margin-bottom: 15px;">[Décrivez l'objet de la convention]</p>
  
  <h3 style="color: #7c3aed; border-bottom: 2px solid #8b5cf6; padding-bottom: 5px;">Article 2 - Durée</h3>
  <p style="margin-bottom: 15px;">[Précisez la durée]</p>
  
  <h3 style="color: #7c3aed; border-bottom: 2px solid #8b5cf6; padding-bottom: 5px;">Article 3 - Conditions</h3>
  <p style="margin-bottom: 15px;">[Détaillez les conditions]</p>
  
  <div style="margin-top: 40px;">
    <p><strong>Fait à [LIEU], le [DATE]</strong></p>
    
    <div style="display: flex; justify-content: space-between; margin-top: 30px;">
      <div style="text-align: center; width: 45%;">
        <p><strong>Pour O'SCOP</strong></p>
        <p style="margin-top: 50px; border-top: 1px solid #000;">Signature</p>
      </div>
      <div style="text-align: center; width: 45%;">
        <p><strong>Le Partenaire</strong></p>
        <p style="margin-top: 50px; border-top: 1px solid #000;">Signature</p>
      </div>
    </div>
  </div>
</div>`
  }
};

